module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message_read clearfix p_background"
  }, [_c('h3', {
    staticClass: "all_title"
  }, [_c('router-link', {
    attrs: {
      "to": "/message_list"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('section', {
    staticClass: "all_container container_box"
  }, [_c('section', {
    staticClass: "message_container word-bw clearfix"
  }, [_c('h2', {
    staticClass: "message_container_title text-center"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('small', {
    staticClass: "tip_sub_text"
  }, [_vm._v(_vm._s(_vm._f("datetime")(_vm.publishTime)))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.content))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4ff79cb2"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/read_message.vue
// module id = 1257
// module chunks = 1